const API_POST = "api/post";

const MIDDLEMAN_RIDE_CANCEL = "middleman/ride/cancel";
const MIDDLEMAN_RIDE_STATUS = "middleman/ride/status";
const MIDDLEMAN_RIDE_REQUEST = "middleman/ride/request";
const MIDDLEMAN_INVALIDATE_REQUEST = "middleman/request/invalidate";
const MIDDLEMAN_CANCEL_PROPOSAL = "middleman/ride/proposal/cancel";

export default {
    API_POST,
    MIDDLEMAN_RIDE_CANCEL,
    MIDDLEMAN_RIDE_STATUS,
    MIDDLEMAN_RIDE_REQUEST,
    MIDDLEMAN_INVALIDATE_REQUEST,
    MIDDLEMAN_CANCEL_PROPOSAL,
}


// WEBPACK FOOTER //
// ./src/Store/Middleware/Backend/types.js